<template>
  <div class="menu-box-item">
    <div class="item-header" :class="{'open': showContent}" @click="showContent = !showContent">
      <div class="item-icon">
        <slot name="icon"></slot>
      </div>
      <div class="item-title">{{title}}</div>
    </div>
    <b-collapse :id="name" v-model="showContent">
      <div class="menu-box-item-content">
        <slot></slot>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BCollapse } from "bootstrap-vue/esm/components/collapse/collapse";
import { VBToggle } from "bootstrap-vue/esm/directives/toggle/toggle";

export default {
  props: ["title", "name", "open"],
  directives: { VBToggle },
  components: { BCollapse },
  data() {
    return {
      showContent: this.open
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/navigation/MenuBoxItem.vue